"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationsErrors = void 0;
const baseError_1 = require("../../../models/error/baseError");
class ValidationsErrors extends baseError_1.BaseError {
    constructor(fieldsErrors) {
        super('Validations Errors');
        this.fieldsErrors = fieldsErrors;
    }
    getErrorsByField(field) {
        return this.fieldsErrors[field];
    }
    getErrors() {
        return this.fieldsErrors;
    }
}
exports.ValidationsErrors = ValidationsErrors;
//# sourceMappingURL=ValidationsErrors.js.map